import './init'; // This must be at the top of the file

// Thanks to italic variant, this is still cheaper than a variable font
import '@fontsource/nunito/400-italic.css';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import '@fontsource/nunito/800.css';

import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { initializeGTM } from './lib/analytics/gtm';
import { queryClient } from './queryClient';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => {
        scope.setLevel('fatal');
        scope.setTag('app-crash', true);
      }}
    >
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

setTimeout(() => {
  initializeGTM();
}, 0);
